import { useEffect, useState } from "react";
import { GetScheduled } from "../../../views/users/admin/config/usecases/GetScheduled";

export const useFetchScheduled = () => {
  const [value, setValue] = useState(null);
  const [rider, setRider] = useState(null);

  useEffect(() => {
    const getSettings = async () => {
      const resp = await GetScheduled();
      if (resp.message === "success") {
        setValue(resp.business);
        setRider(resp.rider);
      } else {
        setValue(null);
        setRider(null);
      }
    };
    getSettings();
  }, []);

  return {
    value,
    rider,
  };
};
